import { render, staticRenderFns } from "./AnswerCollapseList.vue?vue&type=template&id=03094cb6&"
import script from "./AnswerCollapseList.vue?vue&type=script&lang=js&"
export * from "./AnswerCollapseList.vue?vue&type=script&lang=js&"
import style0 from "./AnswerCollapseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports